module.exports = __webpack_public_path__ + "static/media/times-solid.cb6fc82f.svg";